export default __webpack_public_path__ + "static/media/icon_chart_search_blue.7cd48241.svg";